import request from '@/utils/request'

// 创建通知通道
export const createNotification = (data)=>{
  return request({
    url: '/admin-api/client/pc/notice-channel/create',
    method: 'post',
    data: data
  })
}

// 删除通知通道
export const deleteNotification = (id)=>{
  return request({
    url: `/admin-api/client/pc/notice-channel/delete?id=${id}`,
    method: 'delete'
  })
}

// 获得通知通道
export const notificationDetail = (id)=>{
  return request({
    url: `/admin-api/client/pc/notice-channel/get?id=${id}`,
    method: 'get'
  })
}

// 获得通知通道分页
export const notificationList = (params)=>{
  return request({
    url: `/admin-api/client/pc/notice-channel/page`,
    method: 'get',
    params: params
  })
}


// 更新通知通道
export const updateNotification = (data)=>{
  return request({
    url: '/admin-api/client/pc/notice-channel/update',
    method: 'put',
    data: data
  })
}
